<template>
  <modal
      :disableAction="disableAction"
      :showClose="modalConfig.showClose"
      :wrapperClasses="modalConfig.wrapperClasses"
      @action="uploadImage(modalConfig.isStoredImage)"
      @close="closeModal(modalConfig.isStoredImage, true)">
    <h3 slot="header" class="title">{{modalConfig.title}}</h3>
    <p slot="subHeader" v-if="!expandMMS">images containing blatant cannabis verbiage will be blocked by carriers and the campaign will not deliver to your members. if your image does contain cannabis verbiage use the "send image as link" option.</p>
    <div slot="body" class="image-preview-container">
      <div class="image-preview">
        <loading-icon v-if="imageLoading"></loading-icon>
        <img
            v-show="!imageLoading"
            :alt="alt"
            :class="['image', imageClasses]"
            :src="imageSrc"
            @load="setImageLoading"
            @error="$emit('errorLoadingImage', 'unable to load or resize the image, please try again or use another image')">
        <div v-if="modalConfig.isGifImage" class="gif-warning">
          <p class="gif-warning-text">you used a gif - thats awesome! heads up though, gifs cannot be optimized for carrier deliverability. please make sure your gif has a max of 1080 pixels (width), 5000 pixels (height), and 650KB (file size).</p>
        </div>
        <div v-if="disclaimer" class="disclaimer">
          <p class="disclaimer-preview">
              Disclaimer: {{disclaimer}}
          </p>
        </div>
      </div>
      <div v-if="suggestedText" class="suggestedTextWrapper">
        <i class="flaticon-chat-1"></i>
        <div class="suggestedText">
          <p>
            <strong>suggested text</strong><br/><span v-html="suggestedText"></span>
          </p>
        </div>
      </div>
    </div>
    <div slot="action" class="action-wrapper">
      <button
        v-if="modalConfig.actionButton"
        slot="action"
        class="upload-image button larger"
        :disabled="disableAction"
        @click="uploadImage(modalConfig.isStoredImage)">
        {{modalConfig.actionButton}}
      </button>

      <button
        v-if="modalConfig.secondaryButton"
        class="upload-image button larger"
        :disabled="disableAction"
        @click="uploadImageAsLink(modalConfig.isStoredImage)"
      >
        {{ modalConfig.secondaryButton }}
      </button>
    </div>
  </modal>
</template>

<script>
  import Modal from '../shared/Modal'
  import LoadingIcon from '../shared/LoadingIcon'

  export default {
    props: {
      alt: [String, Array],
      disableAction: {
        default: false,
        type: Boolean
      },
      disclaimer: String,
      expandMMS:Boolean,
      imageClasses: String,
      imageSrc: [String, Array],
      isBackup: Boolean,
      isLink: Boolean,
      modalConfig: Object,
      suggestedText: String
    },

    name: 'ImagePreviewModal',

    components: {
      LoadingIcon,
      Modal,
    },

    data() {
      return {
        imageLoading: true,
        sendAsLink: false
      }
    },
    methods: {
      closeModal(isStoredImage, isCancel) {
        this.$emit('close', isCancel, isStoredImage)
      },

      setImageLoading() {
        this.imageLoading = false
      },

      uploadImage(isStoredImage) {
        this.sendAsLink = false;
        this.$emit('upload', this.sendAsLink, isStoredImage)
      },

      uploadImageAsLink(isStoredImage) {
        !this.isBackup && (this.sendAsLink = true)
        this.$emit('upload', this.sendAsLink, isStoredImage)
      }
    },
    created() {
      this.sendAsLink = this.isLink
    },
  }
</script>
